export default __webpack_public_path__ + "static/media/breakfast_12.6c8eefe7.jpg";